import React, { useContext, useEffect, useRef, useState } from 'react';
import { Flex, Form, Input, Select } from 'antd';
import CompanyCreationFormContext, { Country } from '../../../contexts/data/companies/CompanyCreationFormContext';

export default function PhoneFormItem() {
    const formContext = useContext(CompanyCreationFormContext);

    // Only rendered when createNewUser is true, but the context type is a union
    const phone = formContext.user.createNewUser ? formContext.user.phone : '';

    const [selectedCountry, setSelectedCountry] = useState<Country>(formContext.countries[0]);
    const [localNumber, setLocalNumber] = useState('');
    const isInitialized = useRef(false);

    const handleCountryChange = (country: Country) => {
        setSelectedCountry(country);

        const truncatedNumber = localNumber.slice(0, country.maxDigits);
        setLocalNumber(truncatedNumber);
        formContext.onPhoneChange(country.dialCode + truncatedNumber);
    };

    const handleNumberChange = (value: string) => {
        let cleanValue = "";
        cleanValue = value.replace(/\D/g, ''); // Replace all non-digit characters
        cleanValue = cleanValue.replace(/^0/g, ''); // Replace the first character if == 0

        const limitedValue = cleanValue.slice(0, selectedCountry.maxDigits);
        setLocalNumber(limitedValue);
        formContext.onPhoneChange(selectedCountry.dialCode + limitedValue);
    };

    useEffect(() => {
        if (!isInitialized.current && phone) {
            isInitialized.current = true;
            const country = formContext.countries.find((c) => phone.startsWith(c.dialCode));
            if (country) {
                // L'effet est couple a une ref (garde de pagination, generation de fetch) :
                // ecrire cette ref pendant le rendu serait une autre violation. On garde l'effet.
                // eslint-disable-next-line react/set-state-in-effect
                setSelectedCountry(country);
                setLocalNumber(phone.slice(country.dialCode.length));
            } else {
                setLocalNumber(phone);
            }
        }
    }, [phone]);

    return (
        <Form.Item label="Numéro de téléphone" layout="vertical" validateStatus={localNumber.length > 0 && localNumber.length < selectedCountry.maxDigits ? 'error' : undefined} help={localNumber.length > 0 && localNumber.length < selectedCountry.maxDigits ? 'Le numéro de téléphone doit contenir ' + selectedCountry.maxDigits + ' chiffres' : undefined}>
            <Flex gap="8px">
                <Select
                    style={{ width: 'min-content' }}
                    options={formContext.countries.map((country) => ({
                        label: country.flag + ' ' + country.dialCode,
                        value: country.code,
                        country: country,
                    }))}
                    value={selectedCountry.code}
                    onChange={(value, option) => option && handleCountryChange((option as unknown as { country: Country }).country)}
                    optionRender={(option) => (
                        <Flex gap="8px">
                            <span>{(option.data.country.flag)}</span>
                            <span>{(option.data.country.name)}</span>
                            <span style={{ marginLeft: 'auto' }}>{(option.data.country.dialCode)}</span>
                        </Flex>
                    )}
                    popupMatchSelectWidth={false}
                />

                <Input
                    value={localNumber}
                    onChange={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleNumberChange(e.target.value)
                    }}
                    onPaste={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleNumberChange(e.currentTarget.value + e.clipboardData.getData('text'))
                    }}
                    placeholder={`${selectedCountry.code === 'FR' ? '612345678' : ''}`}
                    maxLength={selectedCountry.maxDigits}
                    autoFocus
                    allowClear
                    status={localNumber.length > 0 && localNumber.length < selectedCountry.maxDigits ? 'error' : undefined}
                />
            </Flex>
        </Form.Item>
    );
}